export const VIEW_ENTER = 'withdraw/VIEW_ENTER';
export const RESTRICTIONS_AGREED = 'withdraw/RESTRICTIONS_AGREED';
export const SAVE_AMOUNT = 'withdraw/SAVE_AMOUNT';
export const REQUEST = 'withdraw/REQUEST';
export const SUCCESS = 'withdraw/SUCCESS';
export const FAILURE = 'withdraw/FAILURE';
export const PIN_FAILURE = 'withdraw/PIN_FAILURE';
export const HISTORY_REQUEST = 'withdraw/HISTORY_REQUEST';
export const HISTORY_SUCCESS = 'withdraw/HISTORY_SUCCESS';
export const HISTORY_FAILURE = 'withdraw/HISTORY_FAILURE';
export const CANCEL_REQUEST = 'withdraw/CANCEL_REQUEST';
export const CANCEL_SUCCESS = 'withdraw/CANCEL_SUCCESS';
export const CANCEL_FAILURE = 'withdraw/CANCEL_FAILURE';

export const viewEnter = () => ({
  type: VIEW_ENTER
});

export const restrictionsAgreed = () => ({
  type: RESTRICTIONS_AGREED
});

export const saveAmount = (amount) => ({
  type: SAVE_AMOUNT,
  amount
});

export const request = (pin) => ({
  type: REQUEST,
  pin
});

export const success = (amount) => ({
  type: SUCCESS,
  amount
});
export const failure = (error) => ({
  type: FAILURE,
  error
});

export const pinFailure = (error) => ({
  type: PIN_FAILURE,
  error
});

export const historyRequest = () => ({
  type: HISTORY_REQUEST
});

export const historySuccess = (history) => ({
  type: HISTORY_SUCCESS,
  history
});

export const historyFailure = (error) => ({
  type: HISTORY_FAILURE,
  error
});

export const cancelRequest = () => ({
  type: CANCEL_REQUEST
});

export const cancelSuccess = () => ({
  type: CANCEL_SUCCESS
});

export const cancelFailure = (error) => ({
  type: CANCEL_FAILURE,
  error
});
